import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, switchMap, of, catchError } from 'rxjs';
import { env, python } from 'src/environments/environments';
import { PreRegisterResponse, PreRegisterResponseData, ReEnvioCorreoTempResponseData, RegisterData } from '../interfaces/register-data.interface';
import * as CryptoJS from 'crypto-js';
import { SessionStorageDataService } from 'src/app/services/session-storage-data.service';


@Injectable({
  providedIn: 'root'
})
export class RegisterUserService {
  private readonly url2 = `${python.url_base}`;
  codigoVerificacion: number = 0;
  usuario: string = '';


  constructor(
    private http: HttpClient,
    private router: Router,
    private sessionStorageDataService: SessionStorageDataService
  ) { }


  postPreRegisterUser(data: RegisterData): Observable<PreRegisterResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const urlResource: string = `${this.url2}/preRegister`;

    const domain = sessionStorage.getItem('domain') || '';

    const body = {
      nombre: data.nombre,
      apellido: data.apellido,
      tipoDocIdent: data.tipoDocIdent,
      numDocIdent: data.numDocIdent,
      numTelefono: data.numTelefono,
      correo: data.correo,
      direccion: data.direccion,
      domain: domain,
      status: 1
    };

    return this.http.post<PreRegisterResponse>(urlResource, JSON.stringify(body), { headers }).pipe(
      switchMap(response => {
        if (response.success) {
          return of(response);
        } else {
          return of({
            success: false,
            message: response.message
          });
        }
      }),
      catchError(error => of({
        success: false,
        message: error.message
      }))
    );
  }


  getPreRegisterUserData(userId: string): Observable<PreRegisterResponseData> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const urlResource: string = `${this.url2}/getPreRegister`;

    const body = {
      userId: userId,
    };

    return this.http.post<PreRegisterResponseData>(urlResource, JSON.stringify(body), { headers }).pipe(
      switchMap(response => {
        if (response.success) {
          return of(response);
        } else {
          return of({
            success: false,
            message: response.message
          });
        }
      }),
      catchError(error => of({
        success: false,
        message: error.message
      }))
    );
  }


  postRegisterUser(data: RegisterData, token: any): Observable<{ success: boolean, message: string }> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const urlResource: string = `${this.url2}/register`;

    const body = {
      nombre: data.nombre,
      apellido: data.apellido,
      tipoDocIdent: data.tipoDocIdent,
      numDocIdent: data.numDocIdent,
      correo: data.correo,
      direccion: data.direccion,
      numTelefono: data.numTelefono,
      contrasena_temp: data.contrasena_temp,
      status: 1
    };

    return this.http.post<{ success: boolean, message: string }>(urlResource, JSON.stringify(body), { headers }).pipe(
      switchMap(response => {
        return of({
          success: response.success,
          message: response.message
        });
      }),
      catchError(error => of({
        success: false,
        message: error.message
      }))
    );
  }


  reenviarCorreoVerificacion(correo: string): Observable<ReEnvioCorreoTempResponseData> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const urlResource: string = `${this.url2}/postReEnvCorreoTemp`;
    const domain = sessionStorage.getItem('domain') || '';

    const body = {
      email: correo,
      domain: domain,
    };

    return this.http.post<ReEnvioCorreoTempResponseData>(urlResource, JSON.stringify(body), { headers }).pipe(
      switchMap(response => {
        if (response.success) {
          return of(response);
        } else {
          return of({
            success: false,
            message: response.message
          });
        }
      }),
      catchError(error => of({
        success: false,
        message: error.message
      }))
    );
  }


  // Método auxiliar para asegurar dos dígitos
  private padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}
